import React, { Component } from 'react';
import './OpenItemsViewer.css';
import PropTypes from 'prop-types';
import clipboardPng from '../../../../images/clipboard.png';
import OpenItem from './OpenItem';

class OpenItemsViewer extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape(OpenItem.openItemPropType)),
    onAddOpenItem: PropTypes.func,
    onSelectOpenItem: PropTypes.func,
  };

  static defaultProps = {
    items: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      currentNav: 1,
      lines: 3,
    };
  }

  handleNavClick = (value, event) => {
    event.preventDefault();
    this.setState({
      currentNav: value,
    });
  };

  handleAddButtonClick = (event) => {
    event.preventDefault();
    if (this.props.onAddOpenItem !== undefined) {
      this.props.onAddOpenItem();
    }
  };

  handleClick = (openItemId) => {
    if (this.props.onSelectOpenItem !== undefined) {
      this.props.onSelectOpenItem(openItemId);
    }
  };

  handleShowMore = (event) => {
    event.preventDefault();
    this.setState({
      lines: 0,
    });
  };

  handleShowLess = (event) => {
    event.preventDefault();
    this.setState({
      lines: 3,
    });
  };

  render() {
    return (
      <div className="open-items-viewer">
        <div className="items-navs">
          <div
            className={'nav ' + (this.state.currentNav === 1 ? 'active' : '')}
            onClick={this.handleNavClick.bind(this, 1)}
          >
            Open Items
          </div>
          {
            <div
              className={'nav ' + (this.state.currentNav === 2 ? 'active' : '')}
              onClick={this.handleNavClick.bind(this, 2)}
            >
              Completed
            </div>
          }
        </div>

        <div className="items-container">
          {this.props.items
            .filter((item) =>
              this.state.currentNav === 1
                ? item.status === 'incomplete'
                : item.status === 'complete'
            )
            .map((item, index) => {
              return (
                <OpenItem
                  key={item.id}
                  item={item}
                  onClick={this.handleClick}
                />
              );
            })}
          {this.props.items.length === 0 && (
            <div className="no-items-msg">
              <img src={clipboardPng} alt="no-items" />
              <span>There are no open item yet.</span>
            </div>
          )}

          <div className="button-container">
            <input
              className="btn button button-orange"
              type="button"
              value="Add Open Item"
              onClick={this.handleAddButtonClick}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default OpenItemsViewer;



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/OpenItemsViewer.js